import { NegativeBadge, PositiveBadge, WarningBadge } from 'ui/badge';
import moment from 'moment';
import { displayDate, getNewDate, isDateBefore, DATE_FORMAT_LABEL } from 'utils/date';

type Props = {
  dateTime: number;
};

export const ExpirationBadge = ({ dateTime }: Props) => {
  const expirationDate = moment(dateTime);
  const today = getNewDate();

  const hasExpired = isDateBefore(expirationDate, today);
  const isNearingExpiration = isDateBefore(expirationDate, today.add(30, 'days'));

  if (hasExpired) {
    return <NegativeBadge>{displayDate(expirationDate, DATE_FORMAT_LABEL)}</NegativeBadge>;
  }

  if (isNearingExpiration) {
    return <WarningBadge>{displayDate(expirationDate, DATE_FORMAT_LABEL)}</WarningBadge>;
  }

  return <PositiveBadge>{displayDate(expirationDate, DATE_FORMAT_LABEL)}</PositiveBadge>;
};
